module.exports = __webpack_public_path__ + "img/logo.210a7522.png";